module.exports = __webpack_public_path__ + "media/images/pic/brodno/polygon_news_bigger-2bd3234295edbdd9ae2d2d89054a0cc1.png";